// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"916fdb8d","271":"b148e52f","410":"04c3446e","461":"ad0fb7b8","496":"824a2bce","626":"4c8e2c2c","636":"af745c95","759":"7335299e"}[chunkId] + ".chunk.js";
};